import Stack from '@mui/material/Stack';
import React from 'react';
import { AiWorkBenchOutputEnum } from '../../../utils';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Styles } from '@t2c/shared-fe';
import { TalkingFaceWorkBench } from './TalkingFaceWorkBench';
import { BrollClipWorkBench } from './BrollClipWorkBench';
import { AiTextWorkBench } from './AiTextWorkBench';
import { TextToAudioWorkBench } from './TextToAudioWorkBench';
import { AiImageWorkBench } from './AiImageWorkBench';
import { AiMusicWorkBench } from './AiMusicWorkBench';
import { useMediaQuery, useTheme } from '@mui/material';

interface Props {
  outputType: AiWorkBenchOutputEnum;
  refetch?: () => {};
}
export const InputSection: React.FC<Props> = ({ outputType, refetch }) => {
  const theme = useTheme();
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card sx={{
      ...styles.card,
      border: isExtraSmall ? 'none' : '2px solid',
      p: isExtraSmall ? 0 : 2,
      }}>
      <Typography variant="h6">Input</Typography>
      <Divider
        sx={{
          my: 1.5,
          borderColor: (theme) => theme.palette.background.ternary,
        }}
      />

      {outputType === AiWorkBenchOutputEnum.BROLL && <BrollClipWorkBench refetch={refetch} />}
      {outputType === AiWorkBenchOutputEnum.IMAGE && <AiImageWorkBench refetch={refetch} />}

      {outputType === AiWorkBenchOutputEnum.TALKING_FACE && (
        <TalkingFaceWorkBench refetchTalkingFaces={refetch} />
      )}

      {outputType === AiWorkBenchOutputEnum.TEXT && <AiTextWorkBench />}

      {outputType === AiWorkBenchOutputEnum.VOICEOVER && (
        <TextToAudioWorkBench refetchCreatedAudios={refetch} isPage={false} />
      )}

      {outputType === AiWorkBenchOutputEnum.MUSIC && <AiMusicWorkBench />}
    </Card>
  );
};

const styles: Styles = {
  card: {
    p: 2,
    border: '2px solid',
    borderColor: (theme) => theme.palette.background.border,
    backgroundColor: (theme) => theme.palette.background.primary,
    minHeight: 600,
  },
};
